import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getFeaturedPostFeed, getFeed } from "../Services/DashboardServices";
import React, { useCallback, useContext, useEffect, useState } from "react";
import moment from "moment";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../../App";

export const DashboardFeatureAndPopularPost = () => {
  const [feedLst, setFeelLst] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [carouselKey, setCarouselKey] = useState(0);
  const defaultImage = "/images/placeholder_profile.png";
  const feedDefaultImage = "/images/no-data-found/feed_dummy.png";
  const ApplyLeaveRequestData = useSelector(
    (state) => state?.feedData.feedRequestData
  );
  const [Isloading, setIsloading] = useState(true);
  const toster = useContext(TostMsg);

  useEffect(() => {
    GetFeed();
  }, [ApplyLeaveRequestData]);

  const handleFeedImageError = useCallback((event) => {
    event.target.src = feedDefaultImage;
  }, []);

  //Get Feed List
  async function GetFeed() {
    setIsloading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      EmpGUID: "",
      FeedId: 0,
      pageNumber: 1,
      pageSize: 25,
      LoggedInUserId: userDetails?.EmpId,
      FeedGUID: "",
    };
    try {
      let Feedlst = await getFeaturedPostFeed(body);
      setCarouselKey((prevKey) => prevKey + 1);
      setIsloading(false);
      setFeelLst(Feedlst.Data);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DashboardFeaturePost);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const FeedCarouselTemplate = useCallback((media) => {
    let PostMedia = media?.PostMedia[0];
    let new_MediaPath = PostMedia?.MediaPath;
    const isVideo =
      new_MediaPath?.endsWith(".mp4") ||
      new_MediaPath?.toLowerCase()?.endsWith(".mov");
    const mediaSrc = new_MediaPath;
    return (
      !isVideo &&
      (mediaSrc != undefined ? (
        <img
          src={mediaSrc || feedDefaultImage}
          onError={handleFeedImageError}
          alt="Description of the image"
        />
      ) : (
        ""
      ))
    );
  }, []);

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    const urlRegex =
      /((?:https?:\/\/)?(?:www\.)?(?:app\.orggenie(?:\.com)?\/[^\s]+)|https?:\/\/[^\s]+)/gi;
    const postMention = text?.PostMentions;
    let feedText = text?.FeedText || "";
    feedText = feedText.slice(0, 135);
    feedText = feedText.replace(/(https?:\/\/[^\s]+)(https?:\/\/)/g, "$1 $2");
    feedText = feedText.replace(
      /\b(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:\1)+/gi,
      "$1"
    );
    const usedLinks = new Set();
    let newText = feedText.replace(mentionRegex, (mention) => {
      const matched = postMention?.find(
        (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
      );
      if (matched) {
        return `<a  style="color:rgb(78,168,222);text-decoration:none;">${matched.MentionedName}</a>`;
      }
      return mention.replace("@", "");
    });

    // Replace hashtags
    newText = newText.replace(hashtagRegex, (tag) => {
      const tagText = tag.substring(1);
      return `<a style="color:#c4c6c7;text-decoration:none;">${tag}</a>`;
    });

    // Replace URLs
    newText = newText.replace(urlRegex, (match) => {
      let link = match.trim();
      if (!/^https?:\/\//i.test(link)) link = "https://" + link;
      if (usedLinks.has(link)) return "";
      usedLinks.add(link);
      const internalGoPattern =
        /https?:\/\/app\.orggenie(?:\.com)?\/go\/(Article|Announcement|Award|Policy)(?:\/Detail)?\/([a-zA-Z0-9-]+)(?:\/\d+)?/i;
      const m = link.match(internalGoPattern);
      if (m) {
        const type = m[1];
        const id = m[2];
        const trailingMatch = link.match(/\/[a-zA-Z0-9-]+\/(\d+)$/);
        const extra =
          trailingMatch && link.includes(`/Detail/${id}/`)
            ? `/${trailingMatch[1]}`
            : "";
        // const newLink = `https://app.orggenie.com/${type}/Detail/${id}${extra}`;
        return `<a target="_blank" rel="noopener noreferrer" style="color:#0d6efd;text-decoration:underline;">Click Here</a>`;
      }
      return `<a target="_blank" rel="noopener noreferrer" style="color:#0d6efd;text-decoration:underline;">${link}</a>`;
    });

    return { __html: newText };
  };

  return (
    <>
      {Isloading ? (
        <Skeleton height={270} width="100%" />
      ) : (
        <div className="boxs boxs2 carousel-wrap position-relation">
          {feedLst?.length == 1 ? (
            feedLst?.slice(0, 3)?.map((feature, index) => (
              <Link to={`/Feed/Post/${feature?.GUID}`} key={index}>
                <div className="item" key={index}>
                  <div className="user-block d-flex mb-3">
                    <div className="image">
                      <img
                        src={feature?.ProfilePic || defaultImage}
                        onError={handleImageError}
                        data-demo-src="/images/main-body/user2.jpg"
                        data-user-popover="1"
                        alt=""
                      />
                    </div>
                    <div className="user-info text-left">
                      <Link className="atag" to={`/Profile/${feature?.PostedByGUID}`}>
                        {feature?.PostedBy}
                      </Link>
                      <span className="time">
                        {moment(feature?.CreatedDate).format("MMMM Do YYYY")}
                      </span>
                    </div>
                    {feature?.IsFeatured == 1 && (
                      <div className="featured-star ml-auto" key={index}>
                        <img
                          src="/images/IsFeturedImage.png"
                          title="Featured Post"
                          data-user-popover="1"
                          alt=""
                        />
                      </div>
                    )}
                  </div>
                  {feature?.FeedText ? (
                    <div className="post-text">
                      <p className="text-left pb-2" title={feature?.FeedText}>
                        <p
                          className="small break-text" style={{ whiteSpace: "pre-wrap" }}
                          dangerouslySetInnerHTML={renderFeedText(feature)}
                        ></p>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="post-image">
                    <a className="slide-post-img">
                      {FeedCarouselTemplate(feature)}
                    </a>
                  </div>
                  <div className="card-footer pb-0">
                    <div className="social-count">
                      <div className="likes-count">
                        {feature?.IsLikedByMe != 0 ? (
                          <div className="emojis-group-hand">
                            <img src="/images/main-body/post/emojis/0.gif" />
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-hand-thumbs-up"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                          </svg>
                        )}
                        <span>
                          {feature?.LikesCount >= 1 ? feature?.LikesCount : ""}
                        </span>
                      </div>
                      <div className="comments-count">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chat-right-dots-fill"
                          viewBox="0 0 16 16"
                          style={{
                            color: "rgb(103, 106, 121)",
                            marginLeft: "0.5rem",
                          }}
                        >
                          <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2"></path>
                        </svg>
                        <span>
                          {feature?.TotalComments == 1
                            ? feature?.TotalComments + " Comment"
                            : ""}
                          {feature?.TotalComments >= 2
                            ? feature?.TotalComments + " Comments"
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <OwlCarousel
              key={carouselKey}
              items={1}
              className="owl-theme"
              loop
              autoplay={true}
              autoplayTimeout={3000}
              autoplayHoverPause={true}
              nav={false}
              dots={true}
              margin={8}
            >
              {feedLst?.slice(0, 3)?.map((feature, index) => (
                <Link to={`/Feed/Post/${feature?.GUID}`}>
                  <div className="item" key={index}>
                    <div className="user-block d-flex mb-3">
                      <div className="image">
                        <img
                          src={feature?.ProfilePic || defaultImage}
                          onError={handleImageError}
                          data-demo-src="/images/main-body/user2.jpg"
                          data-user-popover="1"
                          alt=""
                        />
                      </div>
                      <div className="user-info text-left">
                        <Link
                          className="atag"
                           to={`/Profile/${feature?.PostedByGUID}`}
                        >
                          {feature?.PostedBy}
                        </Link>
                        <span className="time">
                          {moment(feature?.CreatedDate).format("MMMM Do YYYY")}
                        </span>
                      </div>
                      {feature?.IsFeatured == 1 && (
                        <div className="featured-star ml-auto" key={index}>
                          <img
                            src="/images/IsFeturedImage.png"
                            title="Featured Post"
                            data-user-popover="1"
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                    {feature?.FeedText ? (
                      <div className="post-text">
                        <p className="text-left pb-2" title={feature?.FeedText}>
                          <p
                            className="small break-text"
                            dangerouslySetInnerHTML={renderFeedText(feature)}
                          ></p>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="post-image">
                      <a className="slide-post-img">
                        {FeedCarouselTemplate(feature)}
                      </a>
                    </div>
                    <div className="card-footer pb-0">
                      <div className="social-count">
                        <div className="likes-count likes-nocount">
                          {feature?.IsLikedByMe != 0 ? (
                            <div className="emojis-group-hand">
                              <img src="/images/main-body/post/emojis/0.gif" />
                            </div>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-hand-thumbs-up"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                            </svg>
                          )}
                          <span>
                            {feature?.LikesCount >= 1
                              ? feature?.LikesCount
                              : ""}
                          </span>
                        </div>
                        <div className="comments-count">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-chat-right-dots-fill"
                            viewBox="0 0 16 16"
                            style={{
                              color: "rgb(103, 106, 121)",
                              marginLeft: "0.5rem",
                            }}
                          >
                            <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2"></path>
                          </svg>
                          <span>
                            {feature?.TotalComments == 1
                              ? feature?.TotalComments + " Comment"
                              : ""}
                            {feature?.TotalComments >= 2
                              ? feature?.TotalComments + " Comments"
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          )}
        </div>
      )}
    </>
  );
};
